export const FlagMapping: {
   [key: string]: string;
} = {
   ad: 'https://halo.ravago.com/assets/country-flags/ad.svg',
   ae: 'https://halo.ravago.com/assets/country-flags/ae.svg',
   af: 'https://halo.ravago.com/assets/country-flags/af.svg',
   ag: 'https://halo.ravago.com/assets/country-flags/ag.svg',
   ai: 'https://halo.ravago.com/assets/country-flags/ai.svg',
   al: 'https://halo.ravago.com/assets/country-flags/al.svg',
   am: 'https://halo.ravago.com/assets/country-flags/am.svg',
   ao: 'https://halo.ravago.com/assets/country-flags/ao.svg',
   aq: 'https://halo.ravago.com/assets/country-flags/aq.svg',
   ar: 'https://halo.ravago.com/assets/country-flags/ar.svg',
   as: 'https://halo.ravago.com/assets/country-flags/as.svg',
   at: 'https://halo.ravago.com/assets/country-flags/at.svg',
   au: 'https://halo.ravago.com/assets/country-flags/au.svg',
   aw: 'https://halo.ravago.com/assets/country-flags/aw.svg',
   ax: 'https://halo.ravago.com/assets/country-flags/ax.svg',
   az: 'https://halo.ravago.com/assets/country-flags/az.svg',
   ba: 'https://halo.ravago.com/assets/country-flags/ba.svg',
   bb: 'https://halo.ravago.com/assets/country-flags/bb.svg',
   bd: 'https://halo.ravago.com/assets/country-flags/bd.svg',
   be: 'https://halo.ravago.com/assets/country-flags/be.svg',
   bf: 'https://halo.ravago.com/assets/country-flags/bf.svg',
   bg: 'https://halo.ravago.com/assets/country-flags/bg.svg',
   bh: 'https://halo.ravago.com/assets/country-flags/bh.svg',
   bi: 'https://halo.ravago.com/assets/country-flags/bi.svg',
   bj: 'https://halo.ravago.com/assets/country-flags/bj.svg',
   bl: 'https://halo.ravago.com/assets/country-flags/bl.svg',
   bm: 'https://halo.ravago.com/assets/country-flags/bm.svg',
   bn: 'https://halo.ravago.com/assets/country-flags/bn.svg',
   bo: 'https://halo.ravago.com/assets/country-flags/bo.svg',
   bq: 'https://halo.ravago.com/assets/country-flags/bq.svg',
   br: 'https://halo.ravago.com/assets/country-flags/br.svg',
   bs: 'https://halo.ravago.com/assets/country-flags/bs.svg',
   bt: 'https://halo.ravago.com/assets/country-flags/bt.svg',
   bv: 'https://halo.ravago.com/assets/country-flags/bv.svg',
   bw: 'https://halo.ravago.com/assets/country-flags/bw.svg',
   by: 'https://halo.ravago.com/assets/country-flags/by.svg',
   bz: 'https://halo.ravago.com/assets/country-flags/bz.svg',
   ca: 'https://halo.ravago.com/assets/country-flags/ca.svg',
   cc: 'https://halo.ravago.com/assets/country-flags/cc.svg',
   cd: 'https://halo.ravago.com/assets/country-flags/cd.svg',
   cf: 'https://halo.ravago.com/assets/country-flags/cf.svg',
   cg: 'https://halo.ravago.com/assets/country-flags/cg.svg',
   ch: 'https://halo.ravago.com/assets/country-flags/ch.svg',
   ci: 'https://halo.ravago.com/assets/country-flags/ci.svg',
   ck: 'https://halo.ravago.com/assets/country-flags/ck.svg',
   cl: 'https://halo.ravago.com/assets/country-flags/cl.svg',
   cm: 'https://halo.ravago.com/assets/country-flags/cm.svg',
   cn: 'https://halo.ravago.com/assets/country-flags/cn.svg',
   co: 'https://halo.ravago.com/assets/country-flags/co.svg',
   cp: 'https://halo.ravago.com/assets/country-flags/cp.svg',
   cr: 'https://halo.ravago.com/assets/country-flags/cr.svg',
   cu: 'https://halo.ravago.com/assets/country-flags/cu.svg',
   cv: 'https://halo.ravago.com/assets/country-flags/cv.svg',
   cw: 'https://halo.ravago.com/assets/country-flags/cw.svg',
   cx: 'https://halo.ravago.com/assets/country-flags/cx.svg',
   cy: 'https://halo.ravago.com/assets/country-flags/cy.svg',
   cz: 'https://halo.ravago.com/assets/country-flags/cz.svg',
   de: 'https://halo.ravago.com/assets/country-flags/de.svg',
   dg: 'https://halo.ravago.com/assets/country-flags/dg.svg',
   dj: 'https://halo.ravago.com/assets/country-flags/dj.svg',
   dk: 'https://halo.ravago.com/assets/country-flags/dk.svg',
   dm: 'https://halo.ravago.com/assets/country-flags/dm.svg',
   do: 'https://halo.ravago.com/assets/country-flags/do.svg',
   dz: 'https://halo.ravago.com/assets/country-flags/dz.svg',
   eac: 'https://halo.ravago.com/assets/country-flags/eac.svg',
   ec: 'https://halo.ravago.com/assets/country-flags/ec.svg',
   ee: 'https://halo.ravago.com/assets/country-flags/ee.svg',
   eg: 'https://halo.ravago.com/assets/country-flags/eg.svg',
   eh: 'https://halo.ravago.com/assets/country-flags/eh.svg',
   er: 'https://halo.ravago.com/assets/country-flags/er.svg',
   es: 'https://halo.ravago.com/assets/country-flags/es.svg',
   et: 'https://halo.ravago.com/assets/country-flags/et.svg',
   eu: 'https://halo.ravago.com/assets/country-flags/eu.svg',
   fi: 'https://halo.ravago.com/assets/country-flags/fi.svg',
   fj: 'https://halo.ravago.com/assets/country-flags/fj.svg',
   fk: 'https://halo.ravago.com/assets/country-flags/fk.svg',
   fm: 'https://halo.ravago.com/assets/country-flags/fm.svg',
   fo: 'https://halo.ravago.com/assets/country-flags/fo.svg',
   fr: 'https://halo.ravago.com/assets/country-flags/fr.svg',
   ga: 'https://halo.ravago.com/assets/country-flags/ga.svg',
   gb: 'https://halo.ravago.com/assets/country-flags/gb.svg',
   gd: 'https://halo.ravago.com/assets/country-flags/gd.svg',
   ge: 'https://halo.ravago.com/assets/country-flags/ge.svg',
   gf: 'https://halo.ravago.com/assets/country-flags/gf.svg',
   gg: 'https://halo.ravago.com/assets/country-flags/gg.svg',
   gh: 'https://halo.ravago.com/assets/country-flags/gh.svg',
   gi: 'https://halo.ravago.com/assets/country-flags/gi.svg',
   gl: 'https://halo.ravago.com/assets/country-flags/gl.svg',
   gm: 'https://halo.ravago.com/assets/country-flags/gm.svg',
   gn: 'https://halo.ravago.com/assets/country-flags/gn.svg',
   gp: 'https://halo.ravago.com/assets/country-flags/gp.svg',
   gq: 'https://halo.ravago.com/assets/country-flags/gq.svg',
   gr: 'https://halo.ravago.com/assets/country-flags/gr.svg',
   gs: 'https://halo.ravago.com/assets/country-flags/gs.svg',
   gt: 'https://halo.ravago.com/assets/country-flags/gt.svg',
   gu: 'https://halo.ravago.com/assets/country-flags/gu.svg',
   gw: 'https://halo.ravago.com/assets/country-flags/gw.svg',
   gy: 'https://halo.ravago.com/assets/country-flags/gy.svg',
   hk: 'https://halo.ravago.com/assets/country-flags/hk.svg',
   hm: 'https://halo.ravago.com/assets/country-flags/hm.svg',
   hn: 'https://halo.ravago.com/assets/country-flags/hn.svg',
   hr: 'https://halo.ravago.com/assets/country-flags/hr.svg',
   ht: 'https://halo.ravago.com/assets/country-flags/ht.svg',
   hu: 'https://halo.ravago.com/assets/country-flags/hu.svg',
   ic: 'https://halo.ravago.com/assets/country-flags/ic.svg',
   id: 'https://halo.ravago.com/assets/country-flags/id.svg',
   ie: 'https://halo.ravago.com/assets/country-flags/ie.svg',
   il: 'https://halo.ravago.com/assets/country-flags/il.svg',
   im: 'https://halo.ravago.com/assets/country-flags/im.svg',
   in: 'https://halo.ravago.com/assets/country-flags/in.svg',
   io: 'https://halo.ravago.com/assets/country-flags/io.svg',
   iq: 'https://halo.ravago.com/assets/country-flags/iq.svg',
   ir: 'https://halo.ravago.com/assets/country-flags/ir.svg',
   is: 'https://halo.ravago.com/assets/country-flags/is.svg',
   it: 'https://halo.ravago.com/assets/country-flags/it.svg',
   je: 'https://halo.ravago.com/assets/country-flags/je.svg',
   jm: 'https://halo.ravago.com/assets/country-flags/jm.svg',
   jo: 'https://halo.ravago.com/assets/country-flags/jo.svg',
   jp: 'https://halo.ravago.com/assets/country-flags/jp.svg',
   ke: 'https://halo.ravago.com/assets/country-flags/ke.svg',
   kg: 'https://halo.ravago.com/assets/country-flags/kg.svg',
   kh: 'https://halo.ravago.com/assets/country-flags/kh.svg',
   ki: 'https://halo.ravago.com/assets/country-flags/ki.svg',
   km: 'https://halo.ravago.com/assets/country-flags/km.svg',
   kn: 'https://halo.ravago.com/assets/country-flags/kn.svg',
   kp: 'https://halo.ravago.com/assets/country-flags/kp.svg',
   kr: 'https://halo.ravago.com/assets/country-flags/kr.svg',
   kw: 'https://halo.ravago.com/assets/country-flags/kw.svg',
   ky: 'https://halo.ravago.com/assets/country-flags/ky.svg',
   kz: 'https://halo.ravago.com/assets/country-flags/kz.svg',
   la: 'https://halo.ravago.com/assets/country-flags/la.svg',
   lb: 'https://halo.ravago.com/assets/country-flags/lb.svg',
   lc: 'https://halo.ravago.com/assets/country-flags/lc.svg',
   li: 'https://halo.ravago.com/assets/country-flags/li.svg',
   lk: 'https://halo.ravago.com/assets/country-flags/lk.svg',
   lr: 'https://halo.ravago.com/assets/country-flags/lr.svg',
   ls: 'https://halo.ravago.com/assets/country-flags/ls.svg',
   lt: 'https://halo.ravago.com/assets/country-flags/lt.svg',
   lu: 'https://halo.ravago.com/assets/country-flags/lu.svg',
   lv: 'https://halo.ravago.com/assets/country-flags/lv.svg',
   ly: 'https://halo.ravago.com/assets/country-flags/ly.svg',
   ma: 'https://halo.ravago.com/assets/country-flags/ma.svg',
   mc: 'https://halo.ravago.com/assets/country-flags/mc.svg',
   md: 'https://halo.ravago.com/assets/country-flags/md.svg',
   me: 'https://halo.ravago.com/assets/country-flags/me.svg',
   mf: 'https://halo.ravago.com/assets/country-flags/mf.svg',
   mg: 'https://halo.ravago.com/assets/country-flags/mg.svg',
   mh: 'https://halo.ravago.com/assets/country-flags/mh.svg',
   mk: 'https://halo.ravago.com/assets/country-flags/mk.svg',
   ml: 'https://halo.ravago.com/assets/country-flags/ml.svg',
   mm: 'https://halo.ravago.com/assets/country-flags/mm.svg',
   mn: 'https://halo.ravago.com/assets/country-flags/mn.svg',
   mo: 'https://halo.ravago.com/assets/country-flags/mo.svg',
   mp: 'https://halo.ravago.com/assets/country-flags/mp.svg',
   mq: 'https://halo.ravago.com/assets/country-flags/mq.svg',
   mr: 'https://halo.ravago.com/assets/country-flags/mr.svg',
   ms: 'https://halo.ravago.com/assets/country-flags/ms.svg',
   mt: 'https://halo.ravago.com/assets/country-flags/mt.svg',
   mu: 'https://halo.ravago.com/assets/country-flags/mu.svg',
   mv: 'https://halo.ravago.com/assets/country-flags/mv.svg',
   mw: 'https://halo.ravago.com/assets/country-flags/mw.svg',
   mx: 'https://halo.ravago.com/assets/country-flags/mx.svg',
   my: 'https://halo.ravago.com/assets/country-flags/my.svg',
   mz: 'https://halo.ravago.com/assets/country-flags/mz.svg',
   na: 'https://halo.ravago.com/assets/country-flags/na.svg',
   nc: 'https://halo.ravago.com/assets/country-flags/nc.svg',
   ne: 'https://halo.ravago.com/assets/country-flags/ne.svg',
   nf: 'https://halo.ravago.com/assets/country-flags/nf.svg',
   ng: 'https://halo.ravago.com/assets/country-flags/ng.svg',
   ni: 'https://halo.ravago.com/assets/country-flags/ni.svg',
   nl: 'https://halo.ravago.com/assets/country-flags/nl.svg',
   no: 'https://halo.ravago.com/assets/country-flags/no.svg',
   np: 'https://halo.ravago.com/assets/country-flags/np.svg',
   nr: 'https://halo.ravago.com/assets/country-flags/nr.svg',
   nu: 'https://halo.ravago.com/assets/country-flags/nu.svg',
   nz: 'https://halo.ravago.com/assets/country-flags/nz.svg',
   om: 'https://halo.ravago.com/assets/country-flags/om.svg',
   pa: 'https://halo.ravago.com/assets/country-flags/pa.svg',
   pc: 'https://halo.ravago.com/assets/country-flags/pc.svg',
   pe: 'https://halo.ravago.com/assets/country-flags/pe.svg',
   pf: 'https://halo.ravago.com/assets/country-flags/pf.svg',
   pg: 'https://halo.ravago.com/assets/country-flags/pg.svg',
   ph: 'https://halo.ravago.com/assets/country-flags/ph.svg',
   pk: 'https://halo.ravago.com/assets/country-flags/pk.svg',
   pl: 'https://halo.ravago.com/assets/country-flags/pl.svg',
   pm: 'https://halo.ravago.com/assets/country-flags/pm.svg',
   pn: 'https://halo.ravago.com/assets/country-flags/pn.svg',
   pr: 'https://halo.ravago.com/assets/country-flags/pr.svg',
   ps: 'https://halo.ravago.com/assets/country-flags/ps.svg',
   pt: 'https://halo.ravago.com/assets/country-flags/pt.svg',
   pw: 'https://halo.ravago.com/assets/country-flags/pw.svg',
   py: 'https://halo.ravago.com/assets/country-flags/py.svg',
   qa: 'https://halo.ravago.com/assets/country-flags/qa.svg',
   re: 'https://halo.ravago.com/assets/country-flags/re.svg',
   ro: 'https://halo.ravago.com/assets/country-flags/ro.svg',
   rs: 'https://halo.ravago.com/assets/country-flags/rs.svg',
   ru: 'https://halo.ravago.com/assets/country-flags/ru.svg',
   rw: 'https://halo.ravago.com/assets/country-flags/rw.svg',
   sa: 'https://halo.ravago.com/assets/country-flags/sa.svg',
   sb: 'https://halo.ravago.com/assets/country-flags/sb.svg',
   sc: 'https://halo.ravago.com/assets/country-flags/sc.svg',
   sd: 'https://halo.ravago.com/assets/country-flags/sd.svg',
   se: 'https://halo.ravago.com/assets/country-flags/se.svg',
   sg: 'https://halo.ravago.com/assets/country-flags/sg.svg',
   sh: 'https://halo.ravago.com/assets/country-flags/sh.svg',
   si: 'https://halo.ravago.com/assets/country-flags/si.svg',
   sj: 'https://halo.ravago.com/assets/country-flags/sj.svg',
   sk: 'https://halo.ravago.com/assets/country-flags/sk.svg',
   sl: 'https://halo.ravago.com/assets/country-flags/sl.svg',
   sm: 'https://halo.ravago.com/assets/country-flags/sm.svg',
   sn: 'https://halo.ravago.com/assets/country-flags/sn.svg',
   so: 'https://halo.ravago.com/assets/country-flags/so.svg',
   sr: 'https://halo.ravago.com/assets/country-flags/sr.svg',
   ss: 'https://halo.ravago.com/assets/country-flags/ss.svg',
   st: 'https://halo.ravago.com/assets/country-flags/st.svg',
   sv: 'https://halo.ravago.com/assets/country-flags/sv.svg',
   sx: 'https://halo.ravago.com/assets/country-flags/sx.svg',
   sy: 'https://halo.ravago.com/assets/country-flags/sy.svg',
   sz: 'https://halo.ravago.com/assets/country-flags/sz.svg',
   tc: 'https://halo.ravago.com/assets/country-flags/tc.svg',
   td: 'https://halo.ravago.com/assets/country-flags/td.svg',
   tf: 'https://halo.ravago.com/assets/country-flags/tf.svg',
   tg: 'https://halo.ravago.com/assets/country-flags/tg.svg',
   th: 'https://halo.ravago.com/assets/country-flags/th.svg',
   tj: 'https://halo.ravago.com/assets/country-flags/tj.svg',
   tk: 'https://halo.ravago.com/assets/country-flags/tk.svg',
   tl: 'https://halo.ravago.com/assets/country-flags/tl.svg',
   tm: 'https://halo.ravago.com/assets/country-flags/tm.svg',
   tn: 'https://halo.ravago.com/assets/country-flags/tn.svg',
   to: 'https://halo.ravago.com/assets/country-flags/to.svg',
   tr: 'https://halo.ravago.com/assets/country-flags/tr.svg',
   tt: 'https://halo.ravago.com/assets/country-flags/tt.svg',
   tv: 'https://halo.ravago.com/assets/country-flags/tv.svg',
   tw: 'https://halo.ravago.com/assets/country-flags/tw.svg',
   tz: 'https://halo.ravago.com/assets/country-flags/tz.svg',
   ua: 'https://halo.ravago.com/assets/country-flags/ua.svg',
   ug: 'https://halo.ravago.com/assets/country-flags/ug.svg',
   um: 'https://halo.ravago.com/assets/country-flags/um.svg',
   un: 'https://halo.ravago.com/assets/country-flags/un.svg',
   us: 'https://halo.ravago.com/assets/country-flags/us.svg',
   uy: 'https://halo.ravago.com/assets/country-flags/uy.svg',
   uz: 'https://halo.ravago.com/assets/country-flags/uz.svg',
   va: 'https://halo.ravago.com/assets/country-flags/va.svg',
   vc: 'https://halo.ravago.com/assets/country-flags/vc.svg',
   ve: 'https://halo.ravago.com/assets/country-flags/ve.svg',
   vg: 'https://halo.ravago.com/assets/country-flags/vg.svg',
   vi: 'https://halo.ravago.com/assets/country-flags/vi.svg',
   vn: 'https://halo.ravago.com/assets/country-flags/vn.svg',
   vu: 'https://halo.ravago.com/assets/country-flags/vu.svg',
   wf: 'https://halo.ravago.com/assets/country-flags/wf.svg',
   ws: 'https://halo.ravago.com/assets/country-flags/ws.svg',
   xk: 'https://halo.ravago.com/assets/country-flags/xk.svg',
   xx: 'https://halo.ravago.com/assets/country-flags/xx.svg',
   ye: 'https://halo.ravago.com/assets/country-flags/ye.svg',
   yt: 'https://halo.ravago.com/assets/country-flags/yt.svg',
   za: 'https://halo.ravago.com/assets/country-flags/za.svg',
   zm: 'https://halo.ravago.com/assets/country-flags/zm.svg',
   zw: 'https://halo.ravago.com/assets/country-flags/zw.svg'
};
